/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { ICON_CHEVRON_LEFT, ICON_LAUNCH } from '../../Icons';
import { SdsIcon } from '../SdsIcon';
import { LinkProps, linkDefaults } from './Link.props';
import { LINK_TYPE_BUTTON, LINK_TYPE_PARAGRAPH } from './types/LinkType.types';

/**
 * SDS Link component.
 */
export const Link = (props: LinkProps): JSX.Element => {
  const { classes, customClick, hideIcon, icon, target, text, type, href, ...rest } = {
    ...linkDefaults,
    ...props,
  };

  // Handle icons
  let linkIcon = null;

  if (!hideIcon) {
    if (icon) {
      linkIcon = icon;
    } else {
      if (type === LINK_TYPE_PARAGRAPH) {
        linkIcon = ICON_LAUNCH;
      } else {
        linkIcon = ICON_CHEVRON_LEFT;
      }
    }
  }

  // Link elements
  const iconTag = `span` as keyof JSX.IntrinsicElements;
  const linkClass = `sds-link link--${type}`;
  const linkContent = (
    <>
      {linkIcon && <SdsIcon classes="sds-link-icon" customTag={iconTag} svg={linkIcon} />}
      <span className="sds-link-text">{text}</span>
    </>
  );

  // Default link case
  let link = (
    <a className={linkClass} href={href} target={target}>
      {linkContent}
    </a>
  );

  // Button link case
  if (type === LINK_TYPE_BUTTON) {
    link = (
      <button
        className={linkClass}
        onClick={(event): void => {
          event.preventDefault();
          customClick && customClick(event);
        }}
      >
        {linkContent}
      </button>
    );
  }

  const wrapperClass = clsx(`sds-link-wrapper`, classes);

  return (
    <span className={wrapperClass} {...rest}>
      {link}
    </span>
  );
};
